// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  padding: 0;
  font-family: "Inter", sans-serif;
}

.layout-container {
  display: flex;
  height: 100vh;
}

.sidebar {
  height: 100%;
  width: 21%;
  align-items: center;
  padding: 24px;
}

.sidebar-admin {
  border-radius: 16px 0px 0px 16px;
  padding: 48px 24px 48px 24px;
  background-color: #506cfe;
  height: 95vh;
  display: flex;
  flex-direction: column;
}

.logo-container {
  height: 44px;
  line-height: 29.05px;
  color: #ffffff;
  width: 228px;
  font-family: "Inter", sans-serif;
}

.dashboard-hr {
  border: 1px solid #ffffff;
  opacity: 0.8;
  margin-top: 20px;
  /* opacity: 2!important; */
}

.sidebar ul {
  list-style: none;
  width: 228px;
  height: 51px;
  border-radius: 8px;
  padding: 16px;
  background-color: #ffffff;
  margin-top: 34px;
}

.sidebar ul li a {
  color: #263238;
  text-decoration: none;
  width: 141px;
  height: 30px;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.36px;
}

.logout-container {
  margin-top: auto;
  padding: 20px;
  text-align: center;
}

.logout-button {
  color: #000000;
  background-color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.header-container {
  display: flex;
  flex-direction: column;
  width: 79%;
  /* padding-left: 10px; */
  background-color: #ffffff;
}

.logo {
  width: 100px;
  /* Adjust size as needed */
  height: auto;
}

.sidebar ul li {
  margin-top: -2px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 10px; */
  padding-left: 38px;
  margin-top: 3%;
}

.search-container {
  display: flex;
  align-items: center;
}

.search-field {
  border: 1px solid #ced4da;
  padding: 12px 20px 12px 40px;
  border-radius: 50px;
  width: 838px;
  height: 42px;
}

.search-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  margin-left: 10px;
}

.user-icon {
  display: flex;
  /* align-items: center; */
  padding-right: 34px;
  /* width: 134px; */
  /* height: 40px; */
}

.user-icon-image {
  /* width: 40px;  */
  height: 35px;
  /* border-radius: 50%; */
  /* border: 2px solid #dee2e6; */
}

.user-icon hr {
  width: 1px;
  background-color: #989898;
  transform: rotate(0deg);
  margin: 0;
  margin-right: 11px;
}

.user-icon-notification {
  width: 19px;
  height: 19px;
  color: #232323;
  margin-top: 7px;
  margin-right: 20px;
}

.main-content {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
  box-sizing: border-box;
}

.user-icon-search {
  position: absolute;
  width: 19px;
  height: 19px;
  top: 47px;
  margin-left: 15px;
  margin-right: 10px;
  color: #606060;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["body,\nhtml {\n  margin: 0;\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n}\n\n.layout-container {\n  display: flex;\n  height: 100vh;\n}\n\n.sidebar {\n  height: 100%;\n  width: 21%;\n  align-items: center;\n  padding: 24px;\n}\n\n.sidebar-admin {\n  border-radius: 16px 0px 0px 16px;\n  padding: 48px 24px 48px 24px;\n  background-color: #506cfe;\n  height: 95vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.logo-container {\n  height: 44px;\n  line-height: 29.05px;\n  color: #ffffff;\n  width: 228px;\n  font-family: \"Inter\", sans-serif;\n}\n\n.dashboard-hr {\n  border: 1px solid #ffffff;\n  opacity: 0.8;\n  margin-top: 20px;\n  /* opacity: 2!important; */\n}\n\n.sidebar ul {\n  list-style: none;\n  width: 228px;\n  height: 51px;\n  border-radius: 8px;\n  padding: 16px;\n  background-color: #ffffff;\n  margin-top: 34px;\n}\n\n.sidebar ul li a {\n  color: #263238;\n  text-decoration: none;\n  width: 141px;\n  height: 30px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 19.36px;\n}\n\n.logout-container {\n  margin-top: auto;\n  padding: 20px;\n  text-align: center;\n}\n\n.logout-button {\n  color: #000000;\n  background-color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n}\n\n.header-container {\n  display: flex;\n  flex-direction: column;\n  width: 79%;\n  /* padding-left: 10px; */\n  background-color: #ffffff;\n}\n\n.logo {\n  width: 100px;\n  /* Adjust size as needed */\n  height: auto;\n}\n\n.sidebar ul li {\n  margin-top: -2px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* padding: 10px; */\n  padding-left: 38px;\n  margin-top: 3%;\n}\n\n.search-container {\n  display: flex;\n  align-items: center;\n}\n\n.search-field {\n  border: 1px solid #ced4da;\n  padding: 12px 20px 12px 40px;\n  border-radius: 50px;\n  width: 838px;\n  height: 42px;\n}\n\n.search-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  margin-left: 10px;\n}\n\n.user-icon {\n  display: flex;\n  /* align-items: center; */\n  padding-right: 34px;\n  /* width: 134px; */\n  /* height: 40px; */\n}\n\n.user-icon-image {\n  /* width: 40px;  */\n  height: 35px;\n  /* border-radius: 50%; */\n  /* border: 2px solid #dee2e6; */\n}\n\n.user-icon hr {\n  width: 1px;\n  background-color: #989898;\n  transform: rotate(0deg);\n  margin: 0;\n  margin-right: 11px;\n}\n\n.user-icon-notification {\n  width: 19px;\n  height: 19px;\n  color: #232323;\n  margin-top: 7px;\n  margin-right: 20px;\n}\n\n.main-content {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.user-icon-search {\n  position: absolute;\n  width: 19px;\n  height: 19px;\n  top: 47px;\n  margin-left: 15px;\n  margin-right: 10px;\n  color: #606060;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
